/**
 * 프로그램별 승인/연결 설정 (.jsx 밖에 두어 TSX가 객체 리터럴의 `=>` 를 JSX로 오인하지 않도록 함)
 */
export function buildAdminFeatureConfigs(h) {
  return [
    {
      key: "wz",
      label: "Wizard",
      tag: "WZ",
      possibleKey: "wz_possible",
      redirect: "/SetPageWz",
      approveHandler: (uid, nickname) => h.handle_WZ_Approve(uid, nickname),
      revokeHandler: (uid, nickname) => h.handle_WZ_Revoke(uid, nickname),
    },
    {
      key: "hedge",
      label: "Hedge",
      tag: "HG",
      possibleKey: "hedge_possible",
      redirect: "/SetPageHedge",
      approveHandler: (uid, nickname) => h.handle_HEDGE_Approve(uid, nickname),
      revokeHandler: (uid, nickname) => h.handle_HEDGE_Revoke(uid, nickname),
    },
    {
      key: "circle",
      label: "Circle",
      tag: "CC",
      possibleKey: "circle_possible",
      redirect: "/SetPageCircle",
      approveHandler: (uid, nickname) => h.handle_CIRCLE_Approve(uid, nickname),
      revokeHandler: (uid, nickname) => h.handle_CIRCLE_Revoke(uid, nickname),
    },
    {
      key: "circlepro",
      label: "Hedge PRO",
      tag: "HP",
      possibleKey: "circlepro_possible",
      redirect: "/SetPageCirclePro",
      approveHandler: (uid, nickname) => h.handle_CIRCLEPRO_Approve(uid, nickname),
      revokeHandler: (uid, nickname) => h.handle_CIRCLEPRO_Revoke(uid, nickname),
    },
    {
      key: "csupreme",
      label: "Circle Pro",
      tag: "CP",
      possibleKey: "csupreme_possible",
      redirect: "/SetPageCSupreme",
      approveHandler: (uid, nickname) => h.handle_CIRCLESUPREME_Approve(uid, nickname),
      revokeHandler: (uid, nickname) => h.handle_CIRCLESUPREME_Revoke(uid, nickname),
    },
    {
      key: "cplus",
      label: "Cplus",
      tag: "CPlus",
      possibleKey: "cplus_possible",
      redirect: "/SetPageCPlus",
      approveHandler: (uid, nickname) => h.handle_CPLUS_Approve(uid, nickname),
      revokeHandler: (uid, nickname) => h.handle_CPLUS_Revoke(uid, nickname),
    },
    {
      key: "hold",
      label: "Hold",
      tag: "HD",
      possibleKey: "hold_possible",
      redirect: "/SetPageHold",
      approveHandler: (uid, nickname) => h.handle_HOLD_Approve(uid, nickname),
      revokeHandler: (uid, nickname) => h.handle_HOLD_Revoke(uid, nickname),
    },
    {
      key: "band",
      label: "Band",
      tag: "BD",
      possibleKey: "band_possible",
      redirect: "/SetPageBand",
      approveHandler: (uid, nickname) => h.handle_BAND_Approve(uid, nickname),
      revokeHandler: (uid, nickname) => h.handle_BAND_Revoke(uid, nickname),
    },
    {
      key: "meme",
      label: "Meme",
      tag: "MM",
      possibleKey: "meme_possible",
      redirect: "/SetPageMeme",
      approveHandler: (uid, nickname) => h.handle_MEME_Approve(uid, nickname),
      revokeHandler: (uid, nickname) => h.handle_MEME_Revoke(uid, nickname),
    },
    {
      key: "escape",
      label: "Escape",
      tag: "ES",
      possibleKey: "escape_possible",
      redirect: "/SetPageEscape",
      approveHandler: (uid, nickname) => h.handle_ESCAPE_Approve(uid, nickname),
      revokeHandler: (uid, nickname) => h.handle_ESCAPE_Revoke(uid, nickname),
    },
  ];
}
